import type { QueryCriteria } from '@openx/types/criteriaExtractors.ts';
import type { ConstValues } from '@openx/types/helpers.ts';
import type { PackageListItem } from '@openx/types/package.ts';
import type { CriteriaDimension } from '@openx/types/tableCriteria.ts';
import type { RowActionBase } from '@openx/types/tableHelpers.ts';

export const PackageRowActionType = {
  DETAILS: 'DETAILS',
  CLONE: 'CLONE',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  CREATE_DEAL: 'CREATE_DEAL',
  USE_SHARED_TARGETING: 'USE_SHARED_TARGETING',
  CHECK_TARGETING: 'CHECK_TARGETING',
} as const;
export type PackageRowActionType = ConstValues<typeof PackageRowActionType>;

export type PackageRowActionsType = Omit<
  Record<PackageRowActionType, RowActionBase<PackageListItem>>,
  | typeof PackageRowActionType.USE_SHARED_TARGETING
  | typeof PackageRowActionType.CLONE
  | typeof PackageRowActionType.CHECK_TARGETING
> &
  Partial<Record<typeof PackageRowActionType.USE_SHARED_TARGETING, RowActionBase<PackageListItem>>> &
  Partial<Record<typeof PackageRowActionType.CLONE, RowActionBase<PackageListItem>>> &
  Partial<Record<typeof PackageRowActionType.CHECK_TARGETING, RowActionBase<PackageListItem>>>;

export type PackageRouteParams = {
  packageId: string;
};

export type DefaultCriteriaOa = {
  filters: QueryCriteria<typeof CriteriaDimension.FILTERS>;
  sort: QueryCriteria<typeof CriteriaDimension.SORT>;
};

export interface CancelablePromise<T> extends Promise<T> {
  cancel: () => void;
}
